import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import {
	organizerListEventsApi,
	organizerScannerAttendeeListApi,
	organizerScannerEventDetailsApi,
} from "../../api/api";
import { handleError } from "../../helpers/handleError";
import { getOrganizerOrderLabel } from "../../helpers/orderNumber";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import "../dashboard.css";

const POLL_INTERVAL_MS = 15000;

const TicketIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M5.5 6.5h13a1.5 1.5 0 0 1 1.5 1.5v2.3a1.7 1.7 0 0 0 0 3.4V16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 16v-2.3a1.7 1.7 0 0 0 0-3.4V8a1.5 1.5 0 0 1 1.5-1.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 6.5v11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeDasharray="2 2" />
  </svg>
);

const CheckIcon = () => (
 <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
<path d="M10.4998 19.9052C10.1632 19.9057 9.8297 19.8397 9.51858 19.711C9.20746 19.5824 8.92481 19.3935 8.68684 19.1553L7.73221 18.1998C7.61631 18.0833 7.47846 17.9909 7.32661 17.9279C7.17477 17.865 7.01196 17.8328 6.84759 17.8332H5.72934C5.0496 17.8325 4.39791 17.5622 3.91726 17.0815C3.43662 16.6009 3.16628 15.9492 3.16559 15.2695V14.1521C3.1661 13.9878 3.13404 13.825 3.07126 13.6732C3.00848 13.5213 2.91623 13.3834 2.79984 13.2675L1.84434 12.3128C1.3643 11.8316 1.09473 11.1796 1.09473 10.4998C1.09473 9.8201 1.3643 9.1681 1.84434 8.68684L2.79984 7.73221C2.91639 7.61631 3.0088 7.47845 3.07173 7.32661C3.13466 7.17477 3.16686 7.01196 3.16646 6.84759V5.72934C3.16716 5.0496 3.43749 4.39791 3.91814 3.91726C4.39878 3.43662 5.05048 3.16628 5.73021 3.16559H6.84759C7.01189 3.1661 7.17467 3.13404 7.32651 3.07126C7.47835 3.00848 7.61624 2.91623 7.73221 2.79984L8.68684 1.84434C9.1681 1.3643 9.8201 1.09473 10.4998 1.09473C11.1796 1.09473 11.8316 1.3643 12.3128 1.84434L13.2675 2.79984C13.3834 2.91639 13.5212 3.0088 13.6731 3.07173C13.8249 3.13466 13.9877 3.16686 14.1521 3.16646H15.2703C15.9501 3.16716 16.6018 3.43749 17.0824 3.91814C17.5631 4.39878 17.8334 5.05048 17.8341 5.73021V6.84759C17.8336 7.01189 17.8656 7.17467 17.9284 7.32651C17.9912 7.47835 18.0834 7.61624 18.1998 7.73221L19.1545 8.68684C19.6345 9.1681 19.9041 9.8201 19.9041 10.4998C19.9041 11.1796 19.6345 11.8316 19.1545 12.3128L18.1998 13.2675C18.0833 13.3834 17.9909 13.5212 17.9279 13.6731C17.865 13.8249 17.8328 13.9877 17.8332 14.1521V15.2703C17.8325 15.9501 17.5622 16.6018 17.0815 17.0824C16.6009 17.5631 15.9492 17.8334 15.2695 17.8341H14.1521C13.9877 17.8337 13.8249 17.8659 13.6731 17.9288C13.5212 17.9918 13.3834 18.0842 13.2675 18.2007L12.3128 19.1553C12.0749 19.3935 11.7922 19.5824 11.4811 19.711C11.17 19.8397 10.8365 19.9057 10.4998 19.9052ZM5.72934 4.47809C5.39756 4.47832 5.07943 4.61022 4.84483 4.84483C4.61022 5.07943 4.47832 5.39756 4.47809 5.72934V6.84759C4.4793 7.18479 4.41348 7.51887 4.28445 7.83042C4.15542 8.14196 3.96575 8.42474 3.72646 8.66234L2.77271 9.61609C2.53825 9.85114 2.40659 10.1696 2.40659 10.5016C2.40659 10.8336 2.53825 11.152 2.77271 11.3871L3.72646 12.3408C3.96554 12.5782 4.15509 12.8607 4.28411 13.172C4.41314 13.4832 4.47907 13.8169 4.47809 14.1538V15.2721C4.47832 15.6039 4.61022 15.922 4.84483 16.1566C5.07943 16.3912 5.39756 16.5231 5.72934 16.5233H6.84759C7.18447 16.5226 7.51816 16.5886 7.82936 16.7176C8.14056 16.8466 8.42308 17.036 8.66059 17.275L9.61434 18.2287C9.84939 18.4632 10.1678 18.5948 10.4998 18.5948C10.8318 18.5948 11.1503 18.4632 11.3853 18.2287L12.3391 17.275C12.5766 17.036 12.8591 16.8466 13.1703 16.7176C13.4815 16.5886 13.8152 16.5226 14.1521 16.5233H15.2703C15.6021 16.5231 15.9202 16.3912 16.1549 16.1566C16.3895 15.922 16.5214 15.6039 16.5216 15.2721V14.1521C16.5206 13.8152 16.5865 13.4814 16.7156 13.1702C16.8446 12.859 17.0341 12.5765 17.2732 12.3391L18.227 11.3853C18.4614 11.1503 18.5931 10.8318 18.5931 10.4998C18.5931 10.1678 18.4614 9.84939 18.227 9.61434L17.2732 8.66234C17.0343 8.42483 16.8449 8.14231 16.7158 7.83111C16.5868 7.51991 16.5208 7.18622 16.5216 6.84934V5.72934C16.5214 5.39756 16.3895 5.07943 16.1549 4.84483C15.9202 4.61022 15.6021 4.47832 15.2703 4.47809H14.1521C13.8149 4.4793 13.4808 4.41348 13.1693 4.28445C12.8577 4.15542 12.5749 3.96575 12.3373 3.72646L11.3836 2.77271C11.1485 2.53825 10.8301 2.40659 10.4981 2.40659C10.1661 2.40659 9.84765 2.53825 9.61259 2.77271L8.66234 3.72646C8.42495 3.96554 8.14245 4.15508 7.83122 4.28411C7.52 4.41314 7.18625 4.47907 6.84934 4.47809H5.72934Z" fill="#2D3035"/>
<path d="M9.62474 12.906C9.53855 12.9062 9.45317 12.8893 9.37356 12.8563C9.29395 12.8232 9.2217 12.7747 9.16099 12.7135L7.41099 10.9635C7.29507 10.8391 7.23197 10.6746 7.23497 10.5045C7.23797 10.3345 7.30684 10.1723 7.42708 10.0521C7.54731 9.93184 7.70952 9.86297 7.87954 9.85997C8.04955 9.85697 8.21409 9.92007 8.33849 10.036L9.62474 11.3214L12.661 8.28599C12.7854 8.17007 12.9499 8.10697 13.12 8.10997C13.29 8.11297 13.4522 8.18184 13.5724 8.30208C13.6926 8.42231 13.7615 8.58452 13.7645 8.75454C13.7675 8.92455 13.7044 9.08909 13.5885 9.21349L10.0885 12.7135C10.0278 12.7747 9.95553 12.8232 9.87593 12.8563C9.79632 12.8893 9.71094 12.9062 9.62474 12.906Z" fill="#2D3035"/>
</svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
<g clip-path="url(#clip0_1057_57)">
<path d="M17.011 14.1267C16.6821 13.8821 16.2172 13.9504 15.9725 14.2792C15.838 14.4601 15.694 14.6375 15.5445 14.8065C15.2731 15.1136 15.3019 15.5827 15.609 15.8542C15.7502 15.979 15.9256 16.0403 16.1003 16.0403C16.3056 16.0403 16.51 15.9556 16.6566 15.7897C16.8336 15.5895 17.0041 15.3794 17.1635 15.1652C17.4081 14.8363 17.3399 14.3713 17.011 14.1267Z" fill="#2D3035"/>
<path d="M18.2523 10.646C17.8521 10.5589 17.4564 10.8129 17.3693 11.2134C17.3213 11.4337 17.2633 11.6544 17.1969 11.8695C17.0758 12.2612 17.2952 12.6767 17.6868 12.7977C17.7598 12.8202 17.8336 12.831 17.9062 12.831C18.2231 12.831 18.5166 12.6263 18.6151 12.3076C18.694 12.0524 18.7628 11.7905 18.8197 11.5291C18.9069 11.1286 18.6528 10.7332 18.2523 10.646Z" fill="#2D3035"/>
<path d="M13.4388 16.5039C13.2417 16.6139 13.0377 16.7167 12.8324 16.8095C12.4588 16.9782 12.2928 17.4178 12.4615 17.7913C12.5854 18.0658 12.8555 18.2282 13.1383 18.2282C13.2404 18.2282 13.3442 18.207 13.4433 18.1623C13.6869 18.0523 13.9288 17.9304 14.1624 17.8C14.5203 17.6002 14.6485 17.148 14.4486 16.7901C14.2488 16.4323 13.7967 16.3042 13.4388 16.5039Z" fill="#2D3035"/>
<path d="M8.75778 3.5625V9.19259L6.03622 11.9141C5.74639 12.204 5.74639 12.6739 6.03622 12.9637C6.18117 13.1087 6.37105 13.1811 6.56105 13.1811C6.75098 13.1811 6.94094 13.1086 7.08589 12.9637L10.0248 10.0248C10.164 9.88564 10.2422 9.69683 10.2422 9.5V3.5625C10.2422 3.15259 9.90988 2.82031 9.49997 2.82031C9.09006 2.82031 8.75778 3.15259 8.75778 3.5625Z" fill="#2D3035"/>
<path d="M18.2578 1.5957C17.8479 1.5957 17.5156 1.92798 17.5156 2.33789V4.3988C15.7881 1.68952 12.7712 0 9.5 0C6.96246 0 4.57681 0.988186 2.78246 2.78246C0.988186 4.57681 0 6.96246 0 9.5C0 12.0375 0.988186 14.4232 2.78246 16.2175C4.57681 18.0118 6.96246 19 9.5 19C9.50627 19 9.51232 18.9992 9.51855 18.9991C9.52479 18.9992 9.53084 19 9.53711 19C9.80459 19 10.0747 18.9887 10.34 18.9665C10.7485 18.9323 11.0519 18.5735 11.0177 18.165C10.9835 17.7565 10.6251 17.453 10.2162 17.4873C9.99189 17.5061 9.76344 17.5156 9.53711 17.5156C9.53084 17.5156 9.52479 17.5164 9.51855 17.5166C9.51232 17.5164 9.50627 17.5156 9.5 17.5156C5.08016 17.5156 1.48438 13.9198 1.48438 9.5C1.48438 5.08016 5.08016 1.48438 9.5 1.48438C12.3484 1.48438 14.9683 3.00263 16.4 5.41797H14.3592C13.9493 5.41797 13.617 5.75025 13.617 6.16016C13.617 6.57007 13.9493 6.90234 14.3592 6.90234H16.625C17.077 6.90234 17.4999 6.77532 17.8599 6.55526C17.883 6.54205 17.9053 6.52784 17.9265 6.51251C18.5725 6.08757 19 5.35663 19 4.52734V2.33789C19 1.92798 18.6677 1.5957 18.2578 1.5957Z" fill="#2D3035"/>
</g>
<defs>
<clipPath id="clip0_1057_57">
<rect width="19" height="19" fill="white"/>
</clipPath>
</defs>
</svg>
);

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M12.2515 7.89663C11.9024 7.84351 11.5923 8.08282 11.5422 8.42401C11.4165 9.28095 11.021 10.0628 10.3984 10.6854C8.81394 12.2699 6.23769 12.2686 4.65381 10.6854C3.07025 9.10151 3.07025 6.52432 4.65381 4.94076C5.2495 4.34538 6.0015 3.9572 6.84312 3.81588C7.20506 3.7472 7.59419 3.73532 7.99794 3.78107C8.55231 3.84488 9.06831 4.02882 9.53919 4.29888L8.7255 4.43782C8.38556 4.49613 8.15662 4.81901 8.21525 5.15926C8.26712 5.46382 8.53144 5.67895 8.8305 5.67895C8.86531 5.67895 8.90069 5.6762 8.93669 5.67007L11.1181 5.29713C11.281 5.26907 11.4269 5.17751 11.5227 5.04201C11.6186 4.90682 11.6564 4.73895 11.6283 4.57538L11.2548 2.39432C11.1974 2.05438 10.8787 1.8267 10.5333 1.88376C10.1934 1.94207 9.96444 2.26526 10.0231 2.60551L10.1214 3.17957C9.51644 2.8402 8.84912 2.62063 8.14012 2.53901C7.60912 2.47857 7.094 2.49538 6.6225 2.5857C5.537 2.76757 4.55069 3.27632 3.77 4.05695C1.69906 6.12788 1.69906 9.49763 3.77 11.5691C4.80544 12.6049 6.16594 13.1225 7.52612 13.1225C8.88662 13.1225 10.2464 12.6049 11.2823 11.5691C12.0959 10.7555 12.6134 9.73076 12.7788 8.60588C12.8289 8.26407 12.5927 7.94663 12.2515 7.89663Z"
      fill="#2D3035"
    />
  </svg>
);

const UserAvatarIcon = () => (
 <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
<path d="M10.7686 7.52663C10.4804 7.38961 10.1863 7.27157 9.88701 7.1727C10.8562 6.4452 11.4844 5.28677 11.4844 3.98438C11.4844 1.7874 9.69699 0 7.49999 0C5.30299 0 3.51561 1.7874 3.51561 3.98438C3.51561 5.2882 4.14515 6.44777 5.11619 7.17513C4.2265 7.46804 3.39169 7.92381 2.66102 8.52481C1.32122 9.62687 0.389666 11.164 0.0380161 12.8532C-0.0721988 13.3825 0.0598422 13.9261 0.400213 14.3447C0.738915 14.7611 1.24115 15 1.7781 15H8.99413C9.31774 15 9.58007 14.7377 9.58007 14.4141C9.58007 14.0904 9.31774 13.8281 8.99413 13.8281H1.7781C1.52797 13.8281 1.37706 13.6885 1.30938 13.6053C1.19252 13.4616 1.14728 13.2745 1.18528 13.092C1.79334 10.1713 4.36959 8.03771 7.34466 7.96576C7.39619 7.96775 7.44796 7.96875 7.49999 7.96875C7.55252 7.96875 7.60481 7.96772 7.65685 7.9657C8.56856 7.98709 9.44542 8.19516 10.2656 8.58504C10.5579 8.72391 10.9074 8.59966 11.0463 8.30736C11.1852 8.0151 11.0609 7.66556 10.7686 7.52663ZM7.6429 6.79327C7.59535 6.79242 7.54771 6.79198 7.49999 6.79198C7.4527 6.79198 7.40542 6.79245 7.35819 6.79333C5.87299 6.71924 4.68749 5.48766 4.68749 3.98438C4.68749 2.43354 5.94916 1.17188 7.49999 1.17188C9.05082 1.17188 10.3125 2.43354 10.3125 3.98438C10.3125 5.48728 9.12758 6.71862 7.6429 6.79327Z" fill="#2D3035"/>
<path d="M10.196 13C10.1168 13.0002 10.0383 12.9826 9.96519 12.9481C9.89204 12.9137 9.82564 12.8631 9.76986 12.7993L8.16184 10.9749C8.05533 10.8452 7.99734 10.6737 8.00009 10.4965C8.00285 10.3192 8.06614 10.1501 8.17662 10.0248C8.2871 9.89942 8.43615 9.82762 8.59237 9.82449C8.74859 9.82137 8.89978 9.88716 9.01409 10.008L10.196 11.348L12.9859 8.18362C13.1002 8.06277 13.2514 7.99698 13.4076 8.00011C13.5638 8.00323 13.7129 8.07503 13.8234 8.20038C13.9339 8.32573 13.9971 8.49484 13.9999 8.67208C14.0027 8.84932 13.9447 9.02085 13.8382 9.15054L10.6221 12.7993C10.5663 12.8631 10.4999 12.9137 10.4268 12.9481C10.3536 12.9826 10.2752 13.0002 10.196 13Z" fill="#2D3035"/>
</svg>
);

function escapeHtml(str) {
	return String(str)
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}

function parseNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function positiveNumber(value, fallback = 0) {
  const num = parseNumber(value);
  return num === null ? fallback : Math.max(num, 0);
}

function formatTime(value) {
  if (!value) return "--:--:--";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "--:--:--";
  return date.toLocaleTimeString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

function formatCountValue(value) {
  const num = Number(value || 0);
  return Number.isFinite(num) ? num.toLocaleString("es-AR") : "0";
}

function getStatusBadge(item) {
  const total = positiveNumber(item?.totalTickets);
  const redeemed = positiveNumber(item?.redeemedCount);
  if (total > 0 && redeemed >= total) return { label: "Todos presentes", variant: "success" };
  if (redeemed > 0) return { label: "Ingreso parcial", variant: "warning" };
  return { label: "Sin ingresos", variant: "secondary" };
}

function getMobileStatusLabel(badge) {
  if (!badge) return "-";
  if (badge.label === "Todos presentes") return "Completo";
  if (badge.label === "Ingreso parcial") return "Parcial";
  return "Pendiente";
}

function getOrderLabel(item) {
  const candidates = [item?.orderid, item?.orderId, item?.orderNumber, item?.order];
  const value = candidates.find((entry) => entry !== undefined && entry !== null && String(entry).trim());
  if (!value) return null;
  const str = String(value).trim().replace(/^#/, "");
  return str ? `#${str}` : null;
}

function getDocumentLabel(item) {
  const candidates = [item?.dni, item?.buyerDni, item?.documentId];
  const value = candidates.find((entry) => entry !== undefined && entry !== null && String(entry).trim());
  return value ? String(value).trim() : null;
}

const EmptyOperationalPanel = ({ title, message }) => (
  <div className="attendance-operational-panel attendance-operational-panel--empty">
    <div className="attendance-operational-panel__head">
      <h3>{title}</h3>
    </div>
    <div className="attendance-unavailable">{message}</div>
  </div>
);

const LiveAttendance = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState("");
  const [eventStats, setEventStats] = useState(null);
  const [attendees, setAttendees] = useState([]);
  const [search, setSearch] = useState("");
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [statusFilterOpen, setStatusFilterOpen] = useState(false);
  const [statusFilterLabel, setStatusFilterLabel] = useState("Todos los estados");
  const [showAllAttendees, setShowAllAttendees] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				setIsLoading(true);
				const res = await organizerListEventsApi();
				const list = Array.isArray(res?.data?.info) ? res.data.info : [];
				setEvents(list);
				const firstWithId = list.find((item) => item?.id || item?._id);
				if (firstWithId) {
					const rawId = firstWithId.id ?? firstWithId._id;
					if (rawId) setSelectedEventId(String(rawId));
				}
			} catch (e) {
				handleError(e);
			} finally {
				setIsLoading(false);
			}
		})();
	}, []);

  useEffect(() => {
    setSearch("");
    setShowAllAttendees(false);
  }, [selectedEventId]);

	useEffect(() => {
		if (!events.length) return;
		if (!selectedEventId) {
			const firstWithId = events.find((item) => item?.id || item?._id);
			if (firstWithId) {
				const rawId = firstWithId.id ?? firstWithId._id;
				if (rawId) setSelectedEventId(String(rawId));
			}
			return;
		}
		const exists = events.some((ev) => {
			const evId = ev?.id ?? ev?._id;
			return evId ? String(evId) === String(selectedEventId) : false;
		});
		if (!exists) setSelectedEventId("");
	}, [events, selectedEventId]);

  useEffect(() => {
    if (!selectedEventId) {
      setEventStats(null);
      setAttendees([]);
      return;
    }
    let cancelled = false;
    const loadAttendance = async () => {
      setAttendanceLoading(true);
      try {
        const [detailRes, listRes] = await Promise.all([
          organizerScannerEventDetailsApi(selectedEventId),
          organizerScannerAttendeeListApi(selectedEventId),
        ]);
        if (cancelled) return;
        setEventStats(detailRes?.data?.info || detailRes?.data || null);
        const attendeeList = Array.isArray(listRes?.data?.info) ? listRes.data.info : [];
        setAttendees(attendeeList);
      } catch (e) {
        if (!cancelled) handleError(e);
      } finally {
        if (!cancelled) setAttendanceLoading(false);
      }
    };
    loadAttendance();
    return () => {
      cancelled = true;
    };
  }, [selectedEventId, refreshKey]);

	const filteredAttendees = useMemo(() => {
		const query = search.trim().toLowerCase();
		const label = statusFilterLabel;

    return attendees.filter((item) => {
      // 1) Filtro por texto
      if (query) {
        const values = [
          item?.name,
          item?.email,
          item?.buyerName,
          item?.buyerEmail,
          item?.dni,
          item?.buyerDni,
          item?.orderid,
          item?.phone,
          item?.buyerPhone,
        ];
        const matchesQuery = values.some((val) => {
          if (val === undefined || val === null) return false;
          return String(val).toLowerCase().includes(query);
        });
        if (!matchesQuery) return false;
      }

      // 2) Filtro por estado
      if (label === "Todos los estados") return true;
      const badge = getStatusBadge(item);
      if (!badge) return true;
      if (label === "Ingreso completo") return badge.label === "Todos presentes";
      if (label === "Ingreso parcial") return badge.label === "Ingreso parcial";
      if (label === "Sin ingresos") return badge.label === "Sin ingresos";
      return true;
    });
  }, [attendees, search, statusFilterLabel]);

  useEffect(() => {
    setShowAllAttendees(false);
  }, [statusFilterLabel]);

  const showMoreAvailable = filteredAttendees.length > 5;
  const displayedAttendees =
    showAllAttendees || !showMoreAvailable ? filteredAttendees : filteredAttendees.slice(0, 5);

  const handleRefreshAttendance = () => {
    if (selectedEventId) setRefreshKey((prev) => prev + 1);
  };

	const handleToggleShowAll = () => {
		setShowAllAttendees((prev) => !prev);
	};

	const handleDownloadPdf = () => {
		if (typeof window === "undefined") return;

		const title = selectedEventName
			? `Seguimiento de asistencia - ${selectedEventName}`
			: "Lista de asistencia";

    const rowsHtml = attendees
      .map((item, idx) => {
        const badge = getStatusBadge(item);
        const total = parseNumber(item?.totalTickets);
        const redeemed = parseNumber(item?.redeemedCount);
        const asistentesLabel = item?.name || item?.buyerName || "Asistente";
        const contactoLabel = item?.email || item?.buyerEmail || "-";
        const documentoLabel = item?.dni || item?.buyerDni || "-";
        const entradaLabel = item?.ticketTypeName || "-";
        const canjesLabel =
          total !== null && redeemed !== null ? `${redeemed} / ${total}` : "-";

				return `
          <tr>
            <td>${idx + 1}</td>
            <td>${escapeHtml(asistentesLabel)}</td>
            <td>${escapeHtml(contactoLabel)}</td>
            <td>${escapeHtml(documentoLabel)}</td>
            <td>${escapeHtml(entradaLabel)}</td>
            <td>${escapeHtml(canjesLabel)}</td>
            <td>${escapeHtml(badge?.label || "-")}</td>
          </tr>
        `;
			})
			.join("");

		const html = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtml(title)}</title>
        <style>
          * { box-sizing: border-box; font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }
          body { margin: 24px; font-size: 13px; color: #111827; }
          h1 { font-size: 18px; margin: 0 0 4px; }
          p { margin: 0 0 12px; color: #6b7280; }
          table { width: 100%; border-collapse: collapse; margin-top: 12px; }
          thead { background: #f3f4f6; }
          th, td { padding: 8px 10px; text-align: left; font-size: 12px; }
          th { text-transform: uppercase; letter-spacing: 0.16em; font-size: 11px; color: #6b7280; }
          tbody tr:nth-child(even) { background: #f9fafb; }
        </style>
      </head>
      <body>
        <h1>${escapeHtml(title)}</h1>
        <p>Generado el ${new Date().toLocaleString("es-AR")}</p>
        <table>
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Asistente</th>
              <th>Email</th>
              <th>Documento</th>
              <th>Entrada</th>
              <th>Canjes</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml || "<tr><td colspan='7'>Sin asistentes para este evento.</td></tr>"}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const selectedEvent = selectedEventId
    ? events.find((ev) => {
        const evId = ev?.id ?? ev?._id;
        return evId ? String(evId) === String(selectedEventId) : false;
      }) || null
    : null;

  const selectedEventName = (() => {
    const raw = selectedEvent?.name || eventStats?.name || "";
    return typeof raw === "string" ? raw : "";
  })();

  const totalSold = Number(eventStats?.bookedTicket || 0) || 0;
  const totalPresent = Number(eventStats?.attendee || 0) || 0;
  const totalPending = totalSold > totalPresent ? totalSold - totalPresent : 0;
  const attendancePercent = totalSold > 0 ? Math.round((totalPresent / totalSold) * 100) : 0;
  const formatCount = (val) => {
    const num = Number(val || 0);
    return Number.isFinite(num) ? num.toLocaleString() : "0";
  };
  function parseNumber(val) {
    const num = Number(val);
    return Number.isFinite(num) ? num : null;
  }

  function getStatusBadge(item) {
    const total = parseNumber(item?.totalTickets);
    const redeemed = parseNumber(item?.redeemedCount);
    if (total !== null && redeemed !== null && total > 0) {
      if (redeemed >= total) return { variant: "success", label: "Todos presentes" };
      if (redeemed > 0) return { variant: "warning", label: "Ingreso parcial" };
      return { variant: "secondary", label: "Sin ingresos" };
    }
    if (item?.is_present) return { variant: "success", label: "Presente" };
    return { variant: "secondary", label: "Ausente" };
  }

  function getMobileStatusLabel(badge) {
    if (!badge) return "";
    if (badge.label === "Todos presentes") return "Ingreso completo";
    if (badge.label === "Ingreso parcial") return "Ingreso parcial";
    if (badge.label === "Sin ingresos") return "Sin ingresos";
    if (badge.label === "Presente") return "Ingreso completo";
    if (badge.label === "Ausente") return "Sin ingresos";
    return badge.label;
  }

  const getOrderLabel = (item) => {
    const candidates = [item?.orderid, item?.orderId, item?.orderNumber, item?.order];
    const value = candidates.find((entry) => entry !== undefined && entry !== null && String(entry).trim());
    if (!value) return null;
    const str = String(value).trim().replace(/^#/, "");
    return str ? `#${str}` : null;
  };

  const getDocumentLabel = (item) => {
    const candidates = [item?.dni, item?.buyerDni, item?.documentId];
    const value = candidates.find((entry) => entry !== undefined && entry !== null && String(entry).trim());
    return value ? String(value).trim() : null;
  };

  const emptyStateContent = attendanceLoading ? (
    <Spinner animation="border" size="sm" />
  ) : search ? (
    "No hay coincidencias para la búsqueda."
  ) : (
    "Aún no hay asistentes registrados para este evento."
  );

  if (isLoading) return <SpinLoading />;

  const clampedPercent = Math.min(Math.max(attendancePercent, 0), 100);

  return (
    <div className="organizer-dashboard">
      <section className="organizer-section">
        <div className="organizer-section__header">
        </div>
        {events.length === 0 ? (
          <div className="organizer-empty-card">
            Todavia no tienes eventos cargados. Crea uno para comenzar a seguir la asistencia en tiempo real.
          </div>
        ) : (
          <div className="attendance-layout">
            <div className="attendance-top-grid">
              <div className="attendance-selector-block">
                <div className="attendance-selector-row">
                  <div className="organizer-field-group attendance-selector">
                    <label htmlFor="event-select">Selecciona un evento</label>
                    <OrganizerPillSelect
                      placeholder="Elegir evento"
                      value={selectedEventId}
                      onChange={(val) => setSelectedEventId(val)}
                      disabled={!events.length}
                      options={events
                        .map((ev) => {
                          const raw = ev?.id ?? ev?._id ?? "";
                          if (!raw) return null;
                          return {
                            value: String(raw),
                            label: ev?.name || "Evento sin nombre",
                          };
                        })
                        .filter(Boolean)}
                    />
                  </div>
                  <div className="attendance-refresh">
                    <label className="sr-only" htmlFor="refresh-attendance">
                      Actualizar asistencia
                    </label>
                    <button
                      id="refresh-attendance"
                      type="button"
                      className="organizer-btn attendance-refresh__button"
                      onClick={handleRefreshAttendance}
                      disabled={!selectedEventId || attendanceLoading}
                    >
                      <span>Actualizar</span>
                      {attendanceLoading && <Spinner animation="border" size="sm" />}
                    </button>
                    <button
                      type="button"
                      className={`organizer-icon-button attendance-refresh__icon-button${
                        attendanceLoading ? " is-loading" : ""
                      }`}
                      onClick={handleRefreshAttendance}
                      disabled={!selectedEventId || attendanceLoading}
                      aria-label="Actualizar asistencia"
                    >
                      <RefreshIcon />
                      {attendanceLoading && (
                        <span className="attendance-refresh__icon-spinner">
                          <Spinner animation="border" size="sm" aria-hidden="true" />
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="attendance-kpi-block">
                {selectedEventId && (
                  <div className="attendance-kpi-row">
                    <article className="organizer-highlight-card attendance-kpi-card">
                      <div className="organizer-highlight-card__icon" aria-hidden="true">
                        <TicketIcon />
                      </div>
                      <div className="organizer-highlight-card__content">
                        <span className="label">VENDIDAS</span>
                        <strong>{formatCount(totalSold)}</strong>
                      </div>
                    </article>
                    <article className="organizer-highlight-card attendance-kpi-card">
                      <div className="organizer-highlight-card__icon" aria-hidden="true">
                        <CheckIcon />
                      </div>
                      <div className="organizer-highlight-card__content">
                        <span className="label">PRESENTES</span>
                        <strong>{formatCount(totalPresent)}</strong>
                      </div>
                    </article>
                    <article className="organizer-highlight-card attendance-kpi-card">
                      <div className="organizer-highlight-card__icon" aria-hidden="true">
                        <ClockIcon />
                      </div>
                      <div className="organizer-highlight-card__content">
                        <span className="label">PENDIENTES</span>
                        <strong>{formatCount(totalPending)}</strong>
                      </div>
                    </article>
                  </div>
                )}
              </div>
              {selectedEventId && (
                <div className="attendance-card-block">
                  <div className="attendance-current-card">
                    <div className="attendance-current-card__row">
                      <div className="attendance-current-card__info">
                        <p className="attendance-current-label">ASISTENCIA ACTUAL</p>
                        <div className="attendance-current-pill">
                          <span className="attendance-current-pill__icon" aria-hidden="true">
                            <UserAvatarIcon />
                          </span>
                          <span className="attendance-current-pill__count">
                            {formatCount(totalPresent)} / {formatCount(totalSold)}
                          </span>
                        </div>
                      </div>
                      <span className="attendance-current-divider" aria-hidden="true" />
                      <div className="attendance-current-card__progress">
                        <div className="attendance-current-progress__track">
                          <div
                            className="attendance-current-progress__bar"
                            style={{ width: `${clampedPercent}%` }}
                          />
                        </div>
                        <div className="attendance-current-progress__meta">
                          <span className="attendance-current-progress__percent">
                            {clampedPercent}%
                          </span>
                          <span
                            className="attendance-current-progress__badge"
                            aria-hidden="true"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {selectedEventId ? (
              <div className="attendance-table-card">
                <header className="attendance-table-card__header">
                  <div className="attendance-table-card__filters">
                    <div className="organizer-filter">
                      <button
                        type="button"
                        className="organizer-chip-button small"
                        onClick={() => setStatusFilterOpen((prev) => !prev)}
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                          <path
                            d="M2 4h12M4 8h8M6.5 12h3"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>Filtrar por: {statusFilterLabel}</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                          <path
                            d="m4 6 4 4 4-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                      {statusFilterOpen && (
                        <div className="organizer-filter__menu">
                          {["Todos los estados", "Ingreso completo", "Ingreso parcial", "Sin ingresos"].map(
                            (label) => (
                              <button
                                type="button"
                                key={label}
                                className={label === statusFilterLabel ? "is-active" : ""}
                                onClick={() => {
                                  setStatusFilterLabel(label);
                                  setStatusFilterOpen(false);
                                }}
                              >
                                {label}
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="attendance-table-card__search">
                    <label className="sr-only" htmlFor="attendance-search">
                      Buscar asistente
                    </label>
                    <div className="attendance-search-input">
                      <Form.Control
                        id="attendance-search"
                        className="organizer-field"
                        placeholder="Buscar asistente por nombre, email, DNI..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <span className="attendance-search-icon" aria-hidden="true">
                        <svg width="16" height="16" viewBox="0 0 16 16">
                          <circle
                            cx="7"
                            cy="7"
                            r="4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.4"
                          />
                          <path
                            d="m10 10 3 3"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </header>
                <div className="attendance-table-card__body">
                  <div className="attendance-table">
                    <Table responsive className="organizer-table__inner align-middle">
                      <thead>
                        <tr className="headerTable">
                          <th>Asistente</th>
                          <th>Contacto</th>
                          <th>Documento</th>
                          <th>Entrada</th>
                          <th>Canjes</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredAttendees.length > 0 ? (
                          displayedAttendees.map((item, idx) => {
                            const key = item?.id || item?._id || item?.orderid || `row-${idx}`;
                            const badge = getStatusBadge(item);
                            const total = parseNumber(item?.totalTickets);
                            const redeemed = parseNumber(item?.redeemedCount);
                            return (
                              <tr key={key}>
                                <td>
                                  <div className="fw-semibold">{item?.name || item?.buyerName || "Asistente"}</div>
                                  {item?.orderid != null && (
                                    <div className="text-muted small">Orden #{item.orderid}</div>
                                  )}
                                  {item?.buyerName && item?.buyerName !== item?.name && (
                                    <div className="text-muted small">Comprador: {item.buyerName}</div>
                                  )}
                                </td>
                                <td>
                                  {item?.email ? <div>{item.email}</div> : <div>-</div>}
                                  {item?.buyerEmail && item?.buyerEmail !== item?.email && (
                                    <div className="text-muted small">Compra: {item.buyerEmail}</div>
                                  )}
                                  {item?.phone && <div className="text-muted small">{item.phone}</div>}
                                  {item?.buyerPhone && item?.buyerPhone !== item?.phone && (
                                    <div className="text-muted small">Compra: {item.buyerPhone}</div>
                                  )}
                                </td>
                                <td>{item?.dni || item?.buyerDni || "-"}</td>
                                <td>
                                  <div>{item?.ticketTypeName || "-"}</div>
                                  {(item?.ticketGate || item?.ticketZone) && (
                                    <div className="text-muted small">
                                      {[item?.ticketGate, item?.ticketZone].filter(Boolean).join(" / ")}
                                    </div>
                                  )}
                                </td>
                                <td>{total !== null && redeemed !== null ? `${redeemed} / ${total}` : "-"}</td>
                                <td>
                                  <span className={`organizer-chip organizer-chip--${badge.variant}`}>
                                    {badge.label}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={6} className="text-center text-muted py-4">
                              {emptyStateContent}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="attendance-mobile-list">
                    {filteredAttendees.length > 0 ? (
                      displayedAttendees.map((item, idx) => {
                        const key = item?.id || item?._id || item?.orderid || `mobile-row-${idx}`;
                        const badge = getStatusBadge(item);
                        const total = parseNumber(item?.totalTickets);
                        const redeemed = parseNumber(item?.redeemedCount);
                        const ratioLabel =
                          total !== null && redeemed !== null ? `${redeemed}/${total}` : "-";
                        const orderLabel = getOrderLabel(item);
                        const documentLabel = getDocumentLabel(item);
                        const statusVariant = badge?.variant || "secondary";
                        return (
                          <article className="attendance-mobile-card" key={key}>
                            <div className="attendance-mobile-card__header">
                              <div className="attendance-mobile-card__info">
                                <p className="attendance-mobile-card__name">
                                  {item?.name || item?.buyerName || "Asistente"}
                                </p>
                                <div className="attendance-mobile-card__rows">
                                  {orderLabel && <span>Orden {orderLabel}</span>}
                                  {documentLabel && <span>DNI: {documentLabel}</span>}
                                </div>
                              </div>
                              <div className="attendance-mobile-card__count">
                                <span className="attendance-mobile-card__ratio">{ratioLabel}</span>
                                {badge && (
                                  <span
                                    className={`attendance-mobile-card__status attendance-mobile-card__status--${statusVariant}`}
                                  >
                                    {getMobileStatusLabel(badge)}
                                  </span>
                                )}
                              </div>
                            </div>
                          </article>
                        );
                      })
                    ) : (
                      <div className="attendance-mobile-empty">{emptyStateContent}</div>
                    )}
                  </div>
                </div>
                <footer className="attendance-table-card__footer">
                  {showMoreAvailable && (
                    <button
                      type="button"
                      className="attendance-table-footer__link"
                      onClick={handleToggleShowAll}
                      aria-expanded={showAllAttendees}
                    >
                      {showAllAttendees ? "- Mostrar menos" : "+ Mostrar más"}
                    </button>
                  )}
                  <button
                    type="button"
                    className="attendance-table-footer__download"
                    onClick={handleDownloadPdf}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                      <path
                        d="M8 2v8.5M5 7.5 8 10.5 11 7.5M3 13.5h10"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Descargar lista</span>
                  </button>
                </footer>
              </div>
            ) : (
              <p className="organizer-section__subtitle">Selecciona un evento para ver el detalle.</p>
            )}
          </div>
        )}

      </section>
    </div>
  );
};

export default LiveAttendance;
